import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Clapperboard, Loader2, Upload } from "lucide-react";

// GIF picker: GIPHY search when the server has a key, otherwise upload-your-own GIF
export default function GifPicker({ onPick, onUploadClick }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [state, setState] = useState({ enabled: null, gifs: [], loading: false });
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      setState((s) => ({ ...s, loading: true }));
      api.get("/island/gifs", { params: { q } }).then((r) => setState({ enabled: r.data.enabled, gifs: r.data.gifs, loading: false })).catch(() => setState({ enabled: false, gifs: [], loading: false }));
    }, 300);
    return () => clearTimeout(t);
  }, [open, q]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><Button variant="ghost" size="icon" title="Send a GIF" data-testid="gif-btn"><Clapperboard className="h-5 w-5 text-pink-500" /></Button></PopoverTrigger>
      <PopoverContent className="glass w-80 p-3 sm:w-96" data-testid="gif-picker">
        {state.enabled === false ? (
          <div className="space-y-2 text-center">
            <Clapperboard className="mx-auto h-8 w-8 text-pink-500/70" />
            <p className="text-sm font-600">GIF search is coming soon</p>
            <p className="text-xs text-muted-foreground">Until the GIPHY key is connected you can send your own GIF files.</p>
            <Button size="sm" variant="outline" className="gold-ring" onClick={() => { setOpen(false); onUploadClick(); }} data-testid="gif-upload-btn"><Upload className="mr-1.5 h-4 w-4" />Upload a GIF</Button>
          </div>
        ) : (
          <>
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search GIPHY…" maxLength={50} className="mb-2 h-9" autoFocus data-testid="gif-search" />
            {state.loading ? <div className="flex h-40 items-center justify-center"><Loader2 className="h-5 w-5 animate-spin" /></div> : (
              <div className="grid max-h-64 grid-cols-3 gap-1.5 overflow-y-auto">
                {state.gifs.map((g) => <button key={g.id} onClick={() => { onPick(g); setOpen(false); }} className="overflow-hidden rounded-md ring-[hsl(var(--gold))] hover:ring-2" data-testid={`gif-${g.id}`}><img src={g.preview_url} alt={g.title} loading="lazy" className="h-20 w-full object-cover" /></button>)}
              </div>
            )}
            <div className="mt-2 flex items-center justify-between text-[0.6rem] text-muted-foreground"><span>Powered by GIPHY</span><button onClick={() => { setOpen(false); onUploadClick(); }} className="text-[hsl(var(--water))]" data-testid="gif-upload-link">Upload my own</button></div>
          </>
        )}
      </PopoverContent>
    </Popover>
  );
}
